import { ReportSeriesModel } from '@Common/Reports/models/report-series.model';
import { MentionSearchFacetTypesEnum } from '../../../../api/mentions/enum/mention-search-facet-types.enum';
import { DataPointModel } from '../../../../Common/Charts/models/data-point.model';
import { SocialSeriesNeoFacetKeysEnum } from '@Social/Intelligence/enums/social-series-neo-facet-keys.enum';
import { ReportSeriesMentionsModel } from '@Common/Reports/models/report-series-mentions.model';


export class TopTermsDataMappers {

    public static neofacetEngagementDataMapper(series: ReportSeriesModel, isHashtagSearch: boolean = false): ReportSeriesMentionsModel['dataMapper'] {
        return (response) => {
            const neoFacet = response.neoFacetResults.find(facet => facet.key === SocialSeriesNeoFacetKeysEnum.mentionsEngagements);
            const values = neoFacet?.buckets.slice(0, 5) ?? [];
            return values.map((val, i) => {
                const filterOverrides = series.mentions.filters.searchCriteria.clone();

                if (isHashtagSearch) {
                    filterOverrides.query.hashtags.include.push(val.termValue);
                } else {
                    filterOverrides.query.keywordGroups[0].and.push(val.termValue);
                }

                return {
                    id: i + '',
                    label: val.termValue,
                    count: val.count,
                    'viewMentionUrl': series.getSocialSeriesUrl(filterOverrides)
                } as DataPointModel;
            });
        };
    }

    public static neofacetImpressionsDataMapper(series: ReportSeriesModel, isHashtagSearch: boolean = false): ReportSeriesMentionsModel['dataMapper'] {
        return (response) => {
            const neoFacet = response.neoFacetResults.find(facet => facet.key === SocialSeriesNeoFacetKeysEnum.mentionsEngagements);
            const values = neoFacet?.buckets
                .map(item => {
                    return {
                        termValue: item.termValue,
                        count: item.buckets[SocialSeriesNeoFacetKeysEnum.mentionsImpressions]?.[0]?.count ?? 0
                    };
                })
                .sort((a, b) => b.count - a.count)
                .slice(0, 5) ?? [];

            return values.map((val, i) => {
                const filterOverrides = series.mentions.filters.searchCriteria.clone();

                if (isHashtagSearch) {
                    filterOverrides.query.hashtags.include.push(val.termValue);
                } else {
                    filterOverrides.query.keywordGroups[0].and.push(val.termValue);
                }

                return {
                    id: i + '',
                    label: val.termValue,
                    count: val.count,
                    'viewMentionUrl': series.getSocialSeriesUrl(filterOverrides)
                } as DataPointModel;
            });
        };
    }

    public static hashtagDataMapper(series: ReportSeriesModel): ReportSeriesMentionsModel['dataMapper'] {
        return (response) => {
            const values = response.facetResults
                .find(facet => facet.field === MentionSearchFacetTypesEnum.hashtags)
                ?.values.slice(0, 5) ?? [];
            return values.map((val, i) => {
                // Add hashtag to filter
                const filterOverrides = series.mentions.filters.searchCriteria.clone();
                filterOverrides.query.hashtags.include.push(val.value);

                return {
                    id: i + '',
                    label: val.value,
                    count: val.count,
                    'viewMentionUrl': series.getSocialSeriesUrl(filterOverrides)
                } as DataPointModel;
            });
        };
    }

    public static wordsDataMapper(series: ReportSeriesModel): ReportSeriesMentionsModel['dataMapper'] {
        return (response) => {
            const values = response.wordCloudResults[0]?.scores.slice(0, 5) ?? [];
            return values.map((val, i) => {
                const filterOverrides = series.mentions.filters.searchCriteria.clone();
                filterOverrides.query.keywordGroups[0].and.push(val.term);

                return {
                    id: i + '',
                    label: val.term,
                    count: val.score,
                    'viewMentionUrl': series.getSocialSeriesUrl(filterOverrides)
                } as DataPointModel;
            });
        };
    }

}
